import {
    Alert,
    Chip,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {useState} from 'react';
import SelectBank from '../../../components/SelectBank';
import {useFetch} from '../../../hooks/useFetch';

export default ({handleChange, setFieldValue, values, id, errors}) => {
    const {data, error, isLoading} = useFetch(`/appointment/${values.id}`);
    console.log(data)
    const [value, setValue] = useState('1');

    const handleTabs = (event, newValue) => {
        setValue(newValue);
    };

    if (isLoading) return null;
    if (error) return <Typography>{error.message}</Typography>;

    return (
        <TabContext value={value}>
            <TabList onChange={handleTabs}>
                <Tab label="Dados do atendimento" value="1" />
                <Tab label="Histórico do atendimento" value="2" />

                <Tab label="Anamnese" value="3" />
            </TabList>
            <TabPanel value="1" sx={{paddingX: 0}}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Stack direction="row" gap={2}>
                            <Chip label={`Status: ${data.status}`} />
                            <Chip label={`Pagamento: ${data.payment_status || 'NOT_PAYMENT'}`} />
                            <Chip label={`Plantão: ${Boolean(data.duty_id) ? 'Sim' : 'Não'}`} />
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.name}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={data.Customer?.name}
                            fullWidth
                            name="name"
                            label="Paciente"
                            error={Boolean(errors.name)}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.professional_number}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={data.Professional?.User?.Person?.name}
                            fullWidth
                            name="professional_number"
                            error={Boolean(errors.professional_number)}
                            label="Profissional"
                            InputProps={{maxLength: 14}}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.phone}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.Product?.name}
                            fullWidth
                            name="phone"
                            label="Especialidade/Produto"
                            InputProps={{maxLength: 11}}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.email}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={new Date(data.datetime).toLocaleString()}
                            error={Boolean(errors.email)}
                            fullWidth
                            name="email"
                            type="email"
                            label="Dia e horário do atendimento"
                            InputProps={{maxLength: 11}}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.document}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={Number(data.amount).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                            fullWidth
                            name="document"
                            error={Boolean(errors.document)}
                            label="Valor do atendimento"
                            InputProps={{maxLength: 14}}
                        />
                    </Grid>
                </Grid>
            </TabPanel>

            <TabPanel value="2" sx={{paddingX: 0}}>
                <Grid container rowGap={2} columnSpacing={2}>
                    {data.History.map(item => (
                        <Grid item xs={12}>
                            <Typography
                                sx={{
                                    maxWidth: 300,
                                    alignSelf: `${
                                        data.Professional.id === item.sender_id
                                            ? 'flex-end'
                                            : 'flex-start'
                                    }`,
                                    background: '#eee',
                                    borderRadius: 2,
                                    padding: 1,
                                }}>
                                {item.body.message}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </TabPanel>

            <TabPanel value="3" sx={{paddingX: 0}}>
                <Grid container rowGap={2}>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.main_complaint}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={data.main_complaint}
                            fullWidth
                            name="main_complaint"
                            label="Queixa principal"
                            error={Boolean(errors.main_complaint)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.current_illness}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={data.current_illness}
                            fullWidth
                            name="current_illness"
                            label="História da Doença Atual"
                            error={Boolean(errors.current_illness)}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.previous_pathological}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={data.previous_pathological}
                            fullWidth
                            name="previous_pathological"
                            label="História Patológica Pregressa"
                            error={Boolean(errors.previous_pathological)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.diagnostic_hypothesis}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={data.diagnostic_hypothesis}
                            fullWidth
                            name="diagnostic_hypothesis"
                            label="Hipótese Diagnóstica"
                            error={Boolean(errors.diagnostic_hypothesis)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.conduct}
                            inputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={data.conduct}
                            fullWidth
                            name="conduct"
                            label="Conduta"
                            error={Boolean(errors.conduct)}
                        />
                    </Grid>
                </Grid>
            </TabPanel>
        </TabContext>
    );
};
